module.exports = __webpack_public_path__ + "media/images/img_side_book-2e0dbf6bba21e849486ede906fc6e812.png";